(() => {
  'use strict';
  const root = document.querySelector('[data-orbit]');
  if (!root) return;
  const q = selector => root.querySelector(selector);
  const all = selector => [...root.querySelectorAll(selector)];
  const cfg = JSON.parse(q('[data-orbit-config]').textContent);
  const form = q('#OrbitForm');
  const selects = all('[data-size-select]');
  const currency = cfg.currency || 'USD';
  const money = cents => new Intl.NumberFormat(cfg.locale || 'en-US', { style: 'currency', currency }).format(cents / 100);
  const base = (cfg.rootUrl || '/').replace(/\/?$/, '/');
  const cartUrl = cfg.cartUrl || base + 'cart';
  const checkoutUrl = base + 'checkout';
  const route = (destination, code = '') => code ? base + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(destination) : destination;
  const storageKey = 'tl-orbit-pending:' + cfg.productId;
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
  let busy = false;
  let navigating = false;
  let pending = null;
  let bagCode = '';
  let stockError = '';
  let bagOpener = null;
  try { bagCode = sessionStorage.getItem(storageKey + ':offer') === cfg.pairCode ? cfg.pairCode : ''; } catch {}

  function sizeOf(variant) {
    const options = variant.selectedOptions || [];
    const named = options.find(option => /size|talla/i.test(option.name));
    const parse = value => String(value || '').trim().match(/^(?:US\s*(?:SIZE\s*)?)?([5-9])(?:\s*US)?$/i)?.[1];
    if (named) return parse(named.value);
    for (const option of options) {
      const size = parse(option.value);
      if (size) return size;
    }
    return String(variant.sku || '').match(/(?:US|size)[ _:#-]*([5-9])\b/i)?.[1];
  }
  const variants = cfg.variants.map(variant => ({ ...variant, id: String(variant.id), size: sizeOf(variant) })).filter(variant => {
    const material = (variant.selectedOptions || []).map(option => option.value).join(' ');
    return variant.size && !/\b(?:moissanite|diamond)\b/i.test(material) && Number.isSafeInteger(Number(variant.id)) && Number.isFinite(variant.price) && variant.price >= 0;
  });
  const byId = id => variants.find(variant => variant.id === String(id));
  const capacity = variant => !variant.available ? 0 : variant.inventory_management && variant.inventory_policy === 'deny' ? Math.max(0, Number(variant.inventory_quantity) || 0) : Infinity;
  const pairEnabled = currency === 'USD' && variants.reduce((sum, variant) => sum + capacity(variant), 0) >= 2;
  const quantity = () => Number(q('[name="orbit-offer"]:checked').value);
  const chosen = (count = quantity()) => selects.slice(0, count).map(select => byId(select.value));

  function savePending(value) {
    pending = value;
    try {
      if (value) sessionStorage.setItem(storageKey, JSON.stringify(value));
      else sessionStorage.removeItem(storageKey);
    } catch { /* A private cart reference still protects retries when storage is unavailable. */ }
  }
  try {
    const saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
    if (saved && /^ORB-[a-z0-9-]+$/i.test(saved.reference) && Array.isArray(saved.items) && saved.items.length > 0 && saved.items.length <= 2 && saved.items.every(item => byId(item.id) && [1, 2].includes(item.quantity)) && [1, 2].includes(saved.items.reduce((sum, item) => sum + item.quantity, 0))) {
      pending = saved;
      pending.quantity = saved.items.reduce((sum, item) => sum + item.quantity, 0);
      pending.code = pending.quantity === 2 ? cfg.pairCode : '';
    }
  } catch { /* Native single-ring form remains available without session storage. */ }
  // Only an acknowledged save is a finished intent. Uncertain requests stay recoverable.
  if (pending?.status === 'saved') savePending(null);

  const explicitId = new URL(location.href).searchParams.get('variant');
  const defaultVariant = explicitId ? byId(explicitId) : variants.find(variant => variant.size === '7' && capacity(variant) > 0) || variants.find(variant => capacity(variant) > 0) || variants[0];
  const secondVariant = defaultVariant?.available ? defaultVariant : variants.find(variant => variant.available) || defaultVariant;
  selects.forEach((select, index) => {
    select.replaceChildren(new Option('Choose a U.S. size', ''));
    [...variants].sort((a, b) => Number(a.size) - Number(b.size)).forEach(variant => {
      const option = new Option('US ' + variant.size + (capacity(variant) > 0 ? '' : ' - unavailable'), variant.id);
      option.disabled = capacity(variant) === 0;
      select.append(option);
    });
    select.value = (index === 0 ? defaultVariant : secondVariant)?.id || '';
  });
  q('[name="orbit-offer"][value="2"]').disabled = !pairEnabled;
  q('[name="orbit-offer"][value="' + (pairEnabled ? 2 : 1) + '"]').checked = true;
  if (pending) {
    const ids = pending.items.flatMap(item => Array(item.quantity).fill(String(item.id)));
    ids.forEach((id, index) => { selects[index].value = id; });
    q('[name="orbit-offer"][value="' + pending.quantity + '"]').checked = true;
    bagCode = pending.code;
  }
  if (currency !== 'USD') q('[data-offer-note]').textContent = 'The ORBITPAIR two-ring offer is available in U.S. dollars. This view shows the live single-ring price in your selected currency.';

  function grouped(selection) {
    const items = new Map();
    selection.forEach(variant => {
      const item = items.get(variant.id) || { id: variant.id, quantity: 0 };
      item.quantity += 1;
      items.set(variant.id, item);
    });
    return [...items.values()];
  }
  function selectionError(selection, cart = null) {
    if (selection.some(variant => !variant)) return 'Choose an available U.S. size for each ring.';
    for (const item of grouped(selection)) {
      const variant = byId(item.id);
      const alreadyInBag = (cart?.items || []).filter(line => String(line.variant_id || line.id) === item.id).reduce((sum, line) => sum + line.quantity, 0);
      if (item.quantity + alreadyInBag > capacity(variant)) return 'US ' + variant.size + ' cannot supply this selection' + (alreadyInBag ? ' with the rings already in your bag' : '') + '. Choose another size or the one-ring option.';
    }
    return '';
  }
  function pricing(selection, count) {
    if (selection.some(variant => !variant)) return { total: 'Choose sizes', unit: '' };
    const prices = selection.map(variant => Math.max(0, variant.price - (count === 2 && currency === 'USD' ? cfg.pairDiscount : 0)));
    return {
      total: money(prices.reduce((sum, price) => sum + price, 0)),
      unit: prices.every(price => price === prices[0]) ? money(prices[0]) : money(Math.min(...prices)) + ' - ' + money(Math.max(...prices))
    };
  }
  function sync() {
    const count = quantity();
    const selection = chosen();
    stockError = selectionError(selection);
    all('[data-slot]').forEach((slot, index) => {
      slot.hidden = index >= count;
      slot.querySelectorAll('select,input').forEach(input => { input.disabled = index >= count || busy || Boolean(pending); });
    });
    q('[data-size-label]').textContent = count === 2 ? 'Ring 1' : 'Your ring';
    q('[data-size-plural]').textContent = count === 2 ? 's' : '';
    for (const offerCount of [1, 2]) {
      const price = pricing(chosen(offerCount), offerCount);
      q('[data-offer-total="' + offerCount + '"]').textContent = price.total;
      q('[data-offer-unit="' + offerCount + '"]').textContent = price.unit ? price.unit + ' / ring' : '';
    }
    const price = pricing(selection, count);
    q('[data-unit-price]').textContent = price.unit || '--';
    q('[data-unit-caption]').textContent = count === 2 ? 'per ring with the pair offer' : 'per ring';
    q('[data-selection-label]').textContent = count + (count === 2 ? ' rings' : ' ring');
    q('[data-selection-total]').textContent = price.total;
    q('[data-selection-unit]').textContent = price.unit ? price.unit + ' per ring' : '';
    q('[data-sticky-price]').textContent = price.total + ' / ' + count + (count === 2 ? ' rings' : ' ring');
    q('[data-pair-saving]').textContent = money(cfg.pairDiscount * 2);
    q('[data-stock-error]').textContent = stockError;
    q('[data-stock-error]').hidden = !stockError || Boolean(pending);
    q('[data-add-label]').textContent = pending ? 'Check my rings in the bag' : 'Add ' + (count === 2 ? 'two rings' : 'ring') + ' to bag';
    q('[data-buy-label]').textContent = pending ? 'Check bag & continue' : 'Buy now - ' + price.total;
    q('[data-sticky-label]').textContent = stockError && !pending ? 'Choose size' : 'Buy now';
    all('[data-add],[data-buy]').forEach(button => { button.disabled = busy || (!pending && Boolean(stockError)); });
    q('[data-sticky-buy]').disabled = busy;
    all('[name="orbit-offer"]').forEach(input => { input.disabled = busy || Boolean(pending) || (input.value === '2' && !pairEnabled); });
    form.setAttribute('aria-busy', String(busy));
  }
  function feedback(text, showBag = false, code = bagCode) {
    q('[data-feedback]').replaceChildren(document.createTextNode(text));
    if (showBag) {
      const link = document.createElement('a');
      link.href = route(cartUrl, code);
      link.textContent = ' View or edit your bag.';
      q('[data-feedback]').append(link);
    }
  }
  function setBusy(value, checkout = false) {
    busy = value;
    q('[data-loading]').hidden = !(value && checkout);
    sync();
  }
  async function request(url, options = {}) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(url, { ...options, signal: controller.signal, headers: { Accept: 'application/json', ...(options.headers || {}) } });
      const data = await response.json();
      if (!response.ok) {
        const error = new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : 'The bag could not be updated. Please try again.');
        error.definiteRejection = response.status >= 400 && response.status < 500 && response.status !== 408 && response.status !== 429;
        throw error;
      }
      return data;
    } finally { clearTimeout(timer); }
  }
  function recovery(cart) {
    const saved = (cart.items || []).filter(line => line.properties?.['_TENLOVE reference'] === pending.reference);
    if (!saved.length) return 'none';
    const quantities = new Map();
    saved.forEach(line => {
      const id = String(line.variant_id || line.id);
      quantities.set(id, (quantities.get(id) || 0) + line.quantity);
    });
    return pending.items.every(item => quantities.get(String(item.id)) === item.quantity) && quantities.size === pending.items.length ? 'complete' : 'partial';
  }
  function renderBag(cart) {
    q('[data-bag-count]').textContent = cart.item_count;
    q('[data-bag-status]').textContent = cart.item_count ? cart.item_count + (cart.item_count === 1 ? ' item in your bag.' : ' items in your bag.') : 'Your bag is empty.';
    const list = q('[data-bag-lines]');
    list.replaceChildren();
    (cart.items || []).forEach(line => {
      const item = document.createElement('li');
      const title = document.createElement('b');
      const detail = document.createElement('span');
      const price = document.createElement('strong');
      title.textContent = line.product_title || line.title || 'Bag item';
      detail.textContent = [line.variant_title === 'Default Title' ? '' : line.variant_title, 'Quantity ' + line.quantity].filter(Boolean).join(' / ');
      price.textContent = Number.isFinite(line.final_line_price) ? money(line.final_line_price) : '';
      item.append(title, detail, price);
      list.append(item);
    });
    q('[data-bag-subtotal]').textContent = Number.isFinite(cart.total_price) ? money(cart.total_price) : 'Confirmed at checkout';
    q('[data-bag-offer]').textContent = bagCode ? 'ORBITPAIR is carried to checkout for eligible rings. The bag subtotal may not include this offer yet. Native checkout confirms discounts, shipping and tax.' : 'Native checkout confirms discounts, shipping and any applicable tax.';
    q('[data-bag-checkout]').href = route(checkoutUrl, bagCode);
    q('[data-native-bag]').href = route(cartUrl, bagCode);
    q('[data-bag-checkout]').hidden = !cart.item_count;
  }
  function showBag() {
    const drawer = q('[data-bag-dialog]');
    bagOpener = document.activeElement;
    if (!drawer.open) drawer.showModal();
  }
  function closeBag() {
    q('[data-bag-dialog]').close();
    bagOpener?.focus();
  }
  async function add(checkout) {
    if (busy || (!pending && stockError)) return;
    setBusy(true, checkout);
    feedback(checkout ? 'Saving your selection and opening secure checkout...' : 'Adding your selection to your bag...');
    let cart;
    let sending = false;
    try {
      cart = await request(base + 'cart.js');
      let state = pending ? recovery(cart) : 'none';
      if (state === 'partial') throw new Error('Part of this saved selection is in your bag. Open your bag and check its contents before trying again; no rings have been added again.');
      if (state === 'none') {
        // A missing reference is not proof that an earlier POST will never commit.
        if (pending) throw new Error('Your selection is still being checked. Open your bag to review it; we will not add a second copy while the first request may still be finishing.');
        const selection = chosen();
        const error = selectionError(selection, cart);
        if (error) {
          throw new Error(error);
        }
        if (!pending) savePending({
          reference: 'ORB-' + (globalThis.crypto?.randomUUID?.() || Date.now().toString(36) + '-' + Math.random().toString(36).slice(2)),
          items: grouped(selection), quantity: quantity(), code: quantity() === 2 ? cfg.pairCode : ''
        });
        sync();
        sending = true;
        const response = await request(base + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: pending.items.map(item => ({ id: Number(item.id), quantity: item.quantity, properties: { '_TENLOVE reference': pending.reference } })) })
        });
        sending = false;
        const accepted = new Map();
        (Array.isArray(response.items) ? response.items : []).forEach(line => {
          const id = String(line.variant_id || line.id);
          accepted.set(id, (accepted.get(id) || 0) + line.quantity);
        });
        if (accepted.size !== pending.items.length || !pending.items.every(item => accepted.get(item.id) === item.quantity)) throw new Error('Please check your bag before trying again. Your whole selection will be checked before another add.');
      }
      bagCode = pending.code || bagCode;
      try { if (bagCode) sessionStorage.setItem(storageKey + ':offer', bagCode); } catch {}
      if (checkout) {
        savePending({ ...pending, status: 'saved' });
        navigating = true;
        location.assign(route(checkoutUrl, bagCode));
        return;
      }
      const count = pending.quantity;
      savePending(null);
      feedback('Added ' + count + (count === 2 ? ' rings' : ' ring') + ' to your bag.', true);
      // Coupon application is a native route, never an acknowledgement gate or cart rewrite.
      try {
        cart = await request(base + 'cart.js');
        renderBag(cart);
        showBag();
      } catch {
        feedback('Your rings were saved. Open your bag to review them and continue.', true);
      }
    } catch (error) {
      navigating = false;
      if (sending && error.definiteRejection) {
        // A rejected multi-item request can still be ambiguous; inspect every referenced line.
        try { if (recovery(await request(base + 'cart.js')) === 'none') savePending(null); } catch {}
      }
      feedback(error.name === 'AbortError' ? 'That took longer than expected. Check your bag; we will only look for your selection, not add it a second time.' : error.message || 'Please check your bag and try again.', true, pending?.code || bagCode);
    } finally {
      if (!navigating) setBusy(false);
    }
  }
  form.addEventListener('submit', event => {
    event.preventDefault();
    add(event.submitter?.hasAttribute('data-buy') || false);
  });
  all('[name="orbit-offer"]').forEach(input => input.addEventListener('change', () => { if (!busy && !pending) sync(); }));
  selects.forEach((select, index) => select.addEventListener('change', () => {
    if (busy || pending) return;
    if (index === 0 && byId(select.value)) {
      const url = new URL(location.href);
      url.searchParams.set('variant', select.value);
      history.replaceState(history.state, '', url);
    }
    sync();
  }));
  q('[data-sticky-buy]').addEventListener('click', () => {
    if (stockError && !pending) {
      q('#OrbitPurchase').scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
      selects.find(select => !select.disabled)?.focus({ preventScroll: true });
    } else add(true);
  });
  q('[data-open-bag]').addEventListener('click', async event => {
    event.preventDefault();
    if (busy) return;
    showBag();
    q('[data-bag-status]').textContent = 'Loading your bag...';
    q('[data-bag-checkout]').hidden = true;
    try { renderBag(await request(base + 'cart.js')); }
    catch { q('[data-bag-status]').textContent = 'Your bag could not be loaded here. Use View or edit your bag below.'; }
  });
  q('[data-close-bag]').addEventListener('click', closeBag);
  q('[data-continue]').addEventListener('click', closeBag);
  q('[data-bag-dialog]').addEventListener('click', event => { if (event.target === q('[data-bag-dialog]')) closeBag(); });
  q('[data-bag-checkout]').addEventListener('click', () => {
    navigating = true;
    setBusy(true, true);
    closeBag();
  });

  const photo = q('[data-main-photo]');
  all('[data-thumb]').forEach(button => button.addEventListener('click', () => {
    photo.src = button.dataset.full;
    photo.srcset = button.dataset.small + ' 600w, ' + button.dataset.full + ' 1200w';
    photo.alt = button.dataset.alt;
    q('[data-photo-index]').textContent = button.dataset.index.padStart(2, '0') + ' / 05';
    all('[data-thumb]').forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb === button)));
  }));
  const lightbox = q('[data-lightbox]');
  q('[data-enlarge]').addEventListener('click', () => {
    lightbox.querySelector('img').src = photo.currentSrc || photo.src;
    lightbox.querySelector('img').alt = photo.alt;
    lightbox.showModal();
  });
  q('[data-close-photo]').addEventListener('click', () => lightbox.close());
  lightbox.addEventListener('click', event => { if (event.target === lightbox) lightbox.close(); });
  if ('IntersectionObserver' in window) new IntersectionObserver(([entry]) => {
    q('[data-sticky]').hidden = entry.isIntersecting || entry.boundingClientRect.top >= 0;
  }).observe(form);

  const video = q('[data-orbit-video]');
  function prepareVideo() {
    video.autoplay = !reduceMotion.matches;
    if (reduceMotion.matches) video.pause();
    const source = video.querySelector('source');
    if (!source.src) { source.src = source.dataset.src; video.load(); }
    if (!reduceMotion.matches) video.play()?.catch(() => {});
  }
  video.autoplay = !reduceMotion.matches;
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) prepareVideo();
      else video.pause();
    }, { rootMargin: '100px' });
    observer.observe(video);
  } else prepareVideo();
  reduceMotion.addEventListener?.('change', () => {
    video.autoplay = !reduceMotion.matches;
    if (reduceMotion.matches) video.pause();
  });
  window.addEventListener('pageshow', () => {
    navigating = false;
    if (pending?.status === 'saved') savePending(null);
    setBusy(false);
  });
  if (pending) feedback('A previous selection needs to be checked. Continue to check its saved reference before another add.', true, pending.code);
  sync();
})();
